import React, { forwardRef } from 'react';
import { useOverlay } from '@react-aria/overlays';
import { useObjectRef } from '../../hooks/useObjectRef';
import { Wrapper } from './styled';
const Overlay = forwardRef(function Overlay(props, externalRef) {
    const { children, color = 'rgb(240 240 243 / 0.7)', isHidden = true, ...rest } = props;
    const ref = useObjectRef(externalRef);
    const { underlayProps } = useOverlay(props, ref);
    return (React.createElement(Wrapper, { ref: ref, "$color": color, "$isHidden": isHidden, ...underlayProps, ...rest }, children));
});
export default Overlay;
